import React, { memo } from 'react'
import Modal from "./Modal"
import CustomButton from "./CustomButton"
import { prefix } from '../../../i18n'
import { CloseMD } from '../normalizer';

const tPaymentMethod = prefix('cart-checkout.payment-method')
const tPaymentSource = prefix('cart-checkout.source')

// ── Field helper — vertical label / value matching the order-show__field ──────
const Field = memo(({ label, value }) => (
  <div className="order-show__field">
    <span className="order-show__field-label">{label}</span>
    <span className="order-show__field-value">{value || "—"}</span>
  </div>
))

const PaymentSourceContent = memo(({ source, validity }) => (
  <div className="order-show__card-grid">
    <Field label={tPaymentSource("entity")}    value={source && source.entity} />
    <Field label={tPaymentSource("reference")} value={source && source.reference} />
    <Field
      label={tPaymentSource("value")}
      value={source && source.value ? `${Number(source.value).toFixed(2)} €` : null}
    />
    {validity > 0 && (
      <Field label={tPaymentMethod("validity")} value={`${validity} dia(s)`} />
    )}
  </div>
))

const OrderPaymentDetailsModal = memo(({ show, close, orderPayment }) => {
  if (orderPayment && orderPayment.provider && orderPayment.provider.payment_method) {
    const { provider, source } = orderPayment
    return (
      <Modal show={show} small untoggle={close}>
        <div className="gl2026-modal__header">
          <h4 className="gl2026-modal__title">{tPaymentMethod("payment-details-title")}</h4>
          <button type="button" className="gl2026-modal__close" onClick={close} aria-label="Fechar">
            <CloseMD />
          </button>
        </div>
        <div className="gl2026-modal__body">
          <PaymentSourceContent source={source} validity={provider.validity} />
        </div>
        <div className="gl2026-modal__footer">
          <CustomButton type="button" onClick={close}>OK</CustomButton>
        </div>
      </Modal>
    )
  }

  // Fallback: no payment data available
  return (
    <Modal show={show} small untoggle={close}>
      <div className="gl2026-modal__header">
        <h4 className="gl2026-modal__title">{tPaymentMethod("payment-details-title")}</h4>
        <button type="button" className="gl2026-modal__close" onClick={close} aria-label="Fechar">
          <CloseMD />
        </button>
      </div>
      <div className="gl2026-modal__body">
        <div className="gl2026-modal__callout gl2026-modal__callout--warning">
          <span>{tPaymentMethod("error.absent-payment-details")}</span>
        </div>
      </div>
      <div className="gl2026-modal__footer">
        <CustomButton type="button" onClick={close}>OK</CustomButton>
      </div>
    </Modal>
  );
});

export default OrderPaymentDetailsModal



